import levenshtein from 'js-levenshtein';
import { findMatch } from './findMatch';
import type { Field, Fields } from '../../../types';
import { setColumn } from './setColumn';

import { Column, Columns, MatchColumnsProps } from '../types';

export const getMatchedColumns = <T extends string>(
  columns: Columns<T>,
  fields: Fields<T>,
  data: MatchColumnsProps<T>['data'],
  autoMapDistance: number,
  autoMapSelectValues?: boolean,
  matcherIgnorePrefixes?: string[]
) =>
  columns.reduce<Column<T>[]>((arr, column) => {
    const autoMatch = findMatch(column.header, fields, autoMapDistance, matcherIgnorePrefixes);
    if (autoMatch) {
      const field = fields.find((field) => field.key === autoMatch) as Field<T>;
      const duplicateIndex = arr.findIndex((column) => 'value' in column && column.value === field.key);
      const duplicate = arr[duplicateIndex];
      if (duplicate && 'value' in duplicate) {
        return levenshtein(duplicate.value, duplicate.header) < levenshtein(autoMatch, column.header)
          ? [
              ...arr.slice(0, duplicateIndex),
              setColumn(arr[duplicateIndex] as Column<T>, field, data, autoMapSelectValues),
              ...arr.slice(duplicateIndex + 1),
              setColumn(column)
            ]
          : [
              ...arr.slice(0, duplicateIndex),
              setColumn(arr[duplicateIndex] as Column<T>),
              ...arr.slice(duplicateIndex + 1),
              setColumn(column, field, data, autoMapSelectValues)
            ];
      } else {
        return [...arr, setColumn(column, field, data, autoMapSelectValues)];
      }
    } else {
      return [...arr, column];
    }
  }, []);
